/**
 * @author        yontaek@zumper.com (Yon Taek Chung)
 * @copyright     Copyright (c) 2019, Zumper
 * @description   Filters prefix helper
 */

import { oforEach, oisEmpty } from '../../../../shared/utils/utils'

const addFilterPrefix = (filters, prefix) => {
  const newFilters = {}
  if (!oisEmpty(filters)) {
    oforEach(filters, (value, key) => {
      newFilters[`${prefix}${key}`] = value
    })
  }
  return newFilters
}

export default addFilterPrefix
